import React, { useState } from 'react';
import Layout from "../components/App/Layout";
import Navbar from "../components/App/Navbar";
import PageBanner from '../components/Common/PageBanner';
import Footer from "../components/App/Footer";
import SEO from "../components/App/SEO";
import shopify_banner from '../assets/images/shopify_banner.jpg';
import ai_banner2 from '../assets/images/ai-banner2.jpg';
import ai_banner3 from '../assets/images/ai_banner3.jpg';
import shopi1 from '../assets/images/shopi1.jpg';
import shopi2 from '../assets/images/shopi2.jpg';
import shopi3 from '../assets/images/shopi3.jpg';
import appservice1 from '../assets/images/appservice1.png';
import appservice2 from '../assets/images/appservice2.png';
import Custom_apss from '../assets/images/Custom_apss.png';
import Custom_apss1 from '../assets/images/Custom_apss1.jpg';
import Arts_Crafts from '../assets/images/Arts-Crafts.png';
import Beauty_Cosmetics from '../assets/images/Beauty-Cosmetics.png';
import Books_Media from '../assets/images/Books-Media.png';
import Electronics_Gadgets from '../assets/images/Electronics_Gadgets.png';
// Add these imports at the top with other image imports
import step1_icon from '../assets/images/step1.png';
import step2_icon from '../assets/images/step2.png';
import step3_icon from '../assets/images/step3.png';
import step4_icon from '../assets/images/step4.png';
import step5_icon from '../assets/images/step5.png';

import Fashion_Apparel from '../assets/images/Fashion-Apparel.png';
import Food_Beverage from '../assets/images/Food-Beverage.png';
import Furniture from '../assets/images/Furniture.png';
import Gifts_Specialty from '../assets/images/Gifts-Specialty.png';
import Home_Goods from '../assets/images/Home-Goods.png';
import Pet_Care from '../assets/images/Pet-Care.png';
import Healthcare_MedTech from '../assets/images/Healthcare-MedTech.png';
import Healthcare from '../assets/images/Healthcare.png';
import Legal_compliance from '../assets/images/Legal_compliance.png';
import Logistics from '../assets/images/Logistics.png';
import Manufacturing from '../assets/images/Manufacturing.png';
import Media from '../assets/images/Media.png';
import Retail from '../assets/images/Retail.png';
import Swal from 'sweetalert2';
import consistent from '../assets/images/consistent.png';
import phonecall from '../assets/images/phonecall.png';
import FunfactComponent from "../components/DynamicPages/FunfactComponent"
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
const sendEmail = async (e) => {
  e.preventDefault()
  // alert('sent successfully');

  const messageBody = `

  Hi,
  
  Name: ${e.target.elements.name.value}
  Phone No: ${e.target.elements.email.value}
  Message: ${e.target.elements.message.value}
  technology:${e.target.elements.technology.value}
  `
  console.log(messageBody);
  try {

    const response = await fetch('https://p8t29dandg.execute-api.ap-south-1.amazonaws.com/prod', {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "no-cors", // no-cors, cors, *same-origin
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: e.target.elements.email.value, messageBody },), // body data type must match "Content-Type" header
    }).then(() => Swal.fire(
      'Mail Sent Successfully!',

    )
    )
    window.location.reload(false);
    ;
    // const json = await response.json()

  } catch (error) {
    console.log(error);
  }
}
const services = [
  {
    title: "Srashta Sticky Add To Cart",
    text: <>Store owners can easily set up different types of rewards programs, Customers get loyalty points.<br /><br />Customers can set up accounts and receive incentives. Additionally, customers who make a minimum purchase can receive prizes. Customers can view the overall stamp count and the minimal cost per stamp. Customers can vire a list of prizes, redeem rewards via a button on their button, and copy a discount coupon they get in the email.</>,
    topics: [
      "Increase sales without paid marketing",
      "Easy to add a rewards program to your Shopify store",
      "Encourage customer repeat purchases through our rewards program"
    ],
    icon: Custom_apss,
  },
  {
    title: "Srashta Sticky Add To Cart",
    text: <>Easy and Fast checkout or add cart | Boost your sales with Sarshta Sticky Add to cart app.<br /><br />Our app is designed to enhance visitor engagement, reduce cart abandonment, and boost conversion rates in your store. Seamlessly integrating with your brand's color palette, it offers a natural and cohesive appearance right from the start. Additionally, you have the flexibility to personalize it to align perfectly with your brand identity.</>,
    topics: [
      "Increase sales without paid marketing",
      "Easy to add a rewards program to your Shopify store",
      "Encourage customer repeat purchases through our rewards program"
    ],
    icon: Custom_apss1,
  },
];

const products = [
  {
    title: "Shopify Apps Development Services Typically Include",
    text: "",
    topics: [
      "<b>Custom App Development:</b> Creating apps with specific features and functionalities not available in existing apps on the Shopify App Store. This can include integrations with other business systems (like ERP, CRM), unique product customization options, advanced reporting, and more.",
      "<b>Public App Development:</b> Building apps that can be listed on the Shopify App Store and used by other Shopify merchants. This requires adherence to Shopify's guidelines and a focus on providing value to a wider audience.",
      "<b>Private App Development:</b> Creating apps specifically for a single Shopify store to address internal workflows or very specific needs. These apps are not listed on the App Store.",
      "<b>App Integration:</b>  Connecting Shopify stores with other third-party services and platforms through custom app development or by utilizing existing APIs.",
      "<b>Ongoing Support and Maintenance:</b> Providing updates, bug fixes, and technical assistance for developed apps.",
      "<b>Shopify App Extensions:</b>  Building extensions to add new features to different areas of Shopify, such as the checkout, POS app, customer accounts, and theme sections.",
    ],
    icon: appservice1,
  },
  {
    title: "Benefits of Using Shopify Apps Development Services",
    text: "Easy and Fast checkout or add cart | Boost your sales with Sarshta Sticky Add to cart app",
    topics: [
      "<b>Customized Functionality:</b>  Get features tailored precisely to your business needs, going beyond the limitations of off-the-shelf apps.",
      "<b>Automation:</b> Automate repetitive tasks like order processing, inventory management, and marketing, saving time and reducing errors.",
      "<b>Seamless Integration:</b> Connect your Shopify store with other crucial business systems for streamlined operations.Improved Customer Experience: Offer unique features, personalized experiences, and better support to your customers.",
      "<b>Enhanced Efficiency:</b> Optimize internal workflows and processes to improve productivity.",
      "<b>Scalability:</b> Build apps that can grow with your business and handle increasing demands.",
      "<b>Competitive Advantage:</b>  Stand out from competitors by offering unique and innovative features to your customers.",
      "<b>Increased Sales and Conversions:</b> : Implement features that encourage purchases, reduce cart abandonment, and improve the overall shopping journey.",
    ],
    icon: appservice2,
  },
];


const industries = [
  {
    title: "Fashion & Apparel",
    icon: Fashion_Apparel,
  },
  {
    title: "Electronics & Gadgets",
    icon: Electronics_Gadgets,
  },
  {
    title: "Beauty & Cosmetics",
    icon: Beauty_Cosmetics,
  },
  {
    title: "Food & Beverage",
    icon: Food_Beverage,
  },
  {
    title: "Home Goods",
    icon: Home_Goods,
  },
  {
    title: "Furniture",
    icon: Furniture,
  },
  {
    title: "Electronics & Gadgets",
    icon: Electronics_Gadgets,
  },
  {
    title: "Arts & Crafts",
    icon: Arts_Crafts,
  },
  {
    title: "Pet Care",
    icon: Pet_Care,
  },
  {
    title: "Books & Media",
    icon: Books_Media,
  },
  {
    title: "Gifts & Specialty",
    icon: Gifts_Specialty,
  },
  {
    title: "Healthcare & MedTech",
    icon: Healthcare_MedTech,
  },

];

// Update the executionSteps array to include icons
const executionSteps = [
  { text: "Project Initiation & Goal Definition", icon: step1_icon },
  { text: "Planning & Strategy", icon: step2_icon },
  { text: "Execution & Task Management", icon: step3_icon },
  { text: "Monitoring & Control", icon: step4_icon },
  { text: "Quality Assurance & Testing", icon: step5_icon },
  { text: "Closure & Review", icon: step5_icon }
];

const faqData = [
  {
    question: 'What AI development services do you offer?',
    answer: 'We offer services like natural language processing, machine learning model development, computer vision, AI consulting, and custom AI solution development.',
  },
  {
    question: 'How can AI benefit my business?',
    answer: 'AI can streamline operations, improve customer service, provide predictive analytics, and automate routine tasks, increasing overall efficiency and innovation.',
  },
  {
    question: 'What industries do you specialize in?',
    answer: 'We specialize in healthcare, finance, e-commerce, manufacturing, and logistics, among other industries.',
  },
];


const IotDevelopment = () => {

  const [openIndex, setOpenIndex] = useState(null);

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <Layout>
      <SEO
        title="Shopify App Development Services | Custom Shopify Expert | SrashtaSoft"
        description="SrashtaSoft provides expert Shopify app development services. Hire Shopify developers to build custom apps, public apps, and integrations for your e-commerce store."
        canonical="https://srashtasoft.com/shopify-development/"
        isServicePage
        serviceName="Shopify App Development Services"
        faqData={faqData}
      />
      <Navbar />

      {/* Hero Section */}
      <section className="hero-section" style={{
        background: `url(${shopify_banner}) no-repeat center center/cover`,
        height: "500px",
        color: "white",
        display: "flex",
        alignItems: "center"
      }}>
        <div className="bg-overlay d-flex align-items-center w-100" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-9">
                <h2 className="fw-bold">
                  Where Luxury Meets Seamless Shopping
                </h2>
                <p className="mt-3 text-white">
                  Where AI Meets Intuitive Design – Crafting Seamless Digital Experiences Powered by Intelligence.
                </p>
                <a href="/contact-us" className="btn btn-custom mt-4">Let’s talk Now!</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-md-6">
              <h2 className="h1 fw-bold text-headings mb-4">
                Build Interfaces Users Love & Technology Understands
              </h2>
              <p className="text-secondary mb-3">
                Shopify plugins, often referred to as apps, are third-party integrations that extend the functionality of your Shopify store. Think of them as add-ons that allow you to customize and enhance your online business without needing to write code yourself. These plugins can automate tasks like email marketing, streamline your shipping process, improve customer service with live chat, offer product reviews, and even help with SEO optimization.
              </p>
              <p className="text-secondary mb-4">
                The beauty of Shopify plugins lies in their ease of installation and use. Typically, you can find and install apps directly from the Shopify App Store with just a few clicks. Many offer free plans or trial periods, allowing you to test their features before committing to a paid subscription. Whether you're looking to boost sales, improve customer engagement, or simplify your backend operations, there's likely a Shopify plugin designed to help. By carefully selecting and integrating the right plugins, you can significantly enhance your store's capabilities and drive business growth.
              </p>

              <a href="/contact-us" className="btn btn-white px-4 py-2" style={{
                color: "#1A2B5F",
                border: "0.6px solid #1A2B5F",
                textDecoration: "none" // optional, to remove underline
              }}>
                Let’s Talk About Your Requirements
              </a>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-6">
                  <img src={shopi1} loading="lazy" className="img-fluid rounded shadow" alt="Generative AI Illustration 1" />
                </div>
                <div className="col-6">
                  <img src={shopi2} loading="lazy" className="img-fluid rounded shadow" alt="Generative AI Illustration 2" />
                </div>
                <div className="col-12 pt-4">
                  <img src={shopi3} loading="lazy" className="img-fluid rounded shadow" alt="Generative AI Illustration 3" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="mb-5 fw-bold text-center" style={{ color: "#1A2B5F", fontSize: "40px" }}>Our shopify apps</h2>
          <div className="row g-4">
            {services.map((service, index) => {
              const isEven = index % 2 === 0;
              const getServiceLink = (title) => {
                switch (title) {
                  case "Srashta Sticky Add To Cart":
                    return "https://apps.shopify.com/srashta-sticky-add-to-cart";
                  default:
                    return "/contact-us";
                }
              };

              return (
                <div className="col-md-6 col-lg-6" key={index} style={{ marginTop: "30px" }}>
                  <div className="card h-100 shadow-sm">
                    <div className="card-body">
                      <div className="d-flex align-items-center">
                        <img src={service.icon} loading="lazy" className="mb-3" alt={service.title} style={{ width: "80px" }} />
                        <h5 className="card-title" style={{ marginLeft: "20px" }}>{service.title}</h5>
                      </div>
                      <p className="card-text text-muted">{service.text}</p>
                      {service.topics && (
                        <ul className="list-unstyled mt-3">
                          {service.topics.map((topic, topicIndex) => (
                            <li key={topicIndex} className="mb-2" style={{
                              display: 'flex',
                              alignItems: 'flex-start'
                            }}>
                              <i className="fas fa-check-circle text-primary me-2 mt-1" style={{ fontSize: "1rem" }}></i>
                              <span style={{ marginLeft: "10px" }} dangerouslySetInnerHTML={{ __html: topic }} />
                            </li>
                          ))}
                        </ul>
                      )}
                      <div className="mt-4">
                        <a
                          href={getServiceLink(service.title)}
                          className="text-decoration-none"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <button
                            className={`btn ${isEven ? 'btn-white' : 'btn-primary'} fw-semibold px-4 py-2`}
                            style={isEven ? {
                              color: "#1A2B5F",
                              border: "0.6px solid #1A2B5F",
                              background: "white"
                            } : {
                              color: "white",
                              border: "none",
                              background: "#0d6efd"
                            }}
                          >
                            View More Details

                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      {/* Banner CTA */}
      <section className="py-5 text-white position-relative" style={{
        background: `url(${ai_banner2}) no-repeat center center/cover`,
        height: "350px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "#007bff40",
          zIndex: 1
        }}></div>

        <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start" style={{ position: "relative", zIndex: 2 }}>
          <h2 className="h3 fw-bold mb-4 mb-md-0" style={{ fontSize: "46px" }}>
            Where Shopify Expertise Meets Cutting-Edge Technology
          </h2>
          <a href="/contact-us/" className="btn btn-light fw-semibold text-dark" style={{
            fontWeight: 500,
            fontSize: "16px",
            lineHeight: "24px",
            letterSpacing: "2%",
            width: "180PX",
            height: "56",
            borderRadius: "6px"
          }}>
            Let’s talk Now!
          </a>
        </div>
      </section>

      {/* Services */}

      {/* Industries */}
      <section className="py-5 bg-white">
        <div className="container text-center">
          <h2 className="fw-bold mb-4" style={{ color: "#1A2B5F" }}>Industries We Serve</h2>
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-6 g-4">
            {industries.map((industry, index) => (
              <div className="col" key={index} style={{
                height: "160px !important",
                marginTop: "24px"
              }}>
                <div className="p-4 shadow-sm h-100 text-center" style={{ borderRadius: "12px", border: "1px solid #E3E3E3" }}>
                  <img
                    src={industry.icon}
                    alt={industry.title}
                    className="mb-3"
                    loading="lazy"
                    style={{ width: "50px", height: "50px", objectFit: "contain" }}
                  />
                  <h5 className="fw-semibold font_size mb-2">{industry.title}</h5>
                  <p className="text-muted small mb-0">{industry.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="mb-5 fw-bold text-center" style={{ color: "#1A2B5F", fontSize: "40px" }}>Bubble Services</h2>
          <div className="row g-4">
            {products.map((service, index) => (
              <div className="col-md-6 col-lg-6" key={index} style={{ marginTop: "30px" }}>
                <div className="card h-100 shadow-sm">
                  <div className="card-body">
                    <img src={service.icon} loading="lazy" className="mb-3" alt={service.title} />
                    <h5 className="card-title">{service.title}</h5>
                    <p className="card-text text-muted">{service.text}</p>
                    {service.topics && (
                      <ul className="list-unstyled mt-3">
                        {service.topics.map((topic, topicIndex) => (
                          <li key={topicIndex} className="mb-2" style={{
                            display: 'flex',
                            alignItems: 'flex-start'
                          }}>
                            <span dangerouslySetInnerHTML={{ __html: topic }} />
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Execution Steps */}
      <section className="bg-primary text-white py-5" style={{
        background: `url(${ai_banner3}) no-repeat center center/cover`,
        height: "660px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundBlendMode: "overlay"
      }}>
        <div className="container text-center" style={{ height: "663px", alignContent: "center" }}>
          <h2 className="fw-bold mb-5" style={{
            fontWeight: 700,
            fontSize: "40px",
            lineHeight: "40px",
            letterSpacing: "2%",
            textAlign: "center",
            textTransform: "capitalize"
          }} >How We Execute Your Project</h2>
          <div className="row justify-content-center gy-4" style={{ height: "313px" }}>
            {executionSteps.map((step, index) => (
              <div className="col-6 col-sm-4 col-md-2" key={index} style={index % 2 !== 0 ? { marginTop: "70px" } : {}}>
                <div className="d-flex flex-column align-items-center">
                  <img
                    src={step.icon}
                    alt={step.text}
                    className="mb-3"
                    style={{ width: "155px", height: "155px", objectFit: "contain" }}
                  />
                  <p className="fw-semibold small text-white mb-0" style={{
                    fontWeight: 700,
                    fontSize: "16px",
                    lineHeight: "24px",
                    letterSpacing: "4%",
                    textAlign: "center",
                    verticalAlign: "middle",
                    textTransform: "capitalize"
                  }}>{step.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-5 bg-white">
        <div className="container">
          <h2
            className="text-center fw-bold mb-4"
            style={{
              fontWeight: 700,
              fontSize: "40px",
              lineHeight: "100%",
              letterSpacing: "0%",
              textTransform: "capitalize",
            }}
          >
            FAQs: Shopify Development Services
          </h2>

          <div className="panel-group wrap" id="bs-collapse">

            <Accordion allowZeroExpanded>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What types of Shopify apps can you develop?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    We develop both public and custom Shopify apps tailored to your store’s needs. This includes apps for inventory management, shipping, payment gateways, subscriptions, loyalty programs, custom checkout flows, analytics dashboards, and third-party integrations.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What Shopify APIs are you proficient in?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p> We are proficient in all major Shopify APIs, including: </p>
                  <p>Admin API (for managing products, orders, and customers)</p>
                  <p>Storefront API (for custom storefronts and headless commerce)</p>
                  <p>Checkout API, Payments API, and Partner API We ensure seamless integration, performance, and secure API usage for both front-end and back-end features.</p>

                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What are Shopify App Extensions and when are they useful?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p> Shopify App Extensions are ready-made UI components that let your app extend the Shopify admin, POS, or checkout. They are useful when you want to:</p>
                  <p>Add quick actions in the admin</p>
                  <p>Customize the checkout experience</p>
                  <p>Integrate smoothly with Shopify’s interface They reduce development time and offer a native, consistent user experience within Shopify.</p>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </section>
      <FunfactComponent />
      <section className='need-help-section' id='need-help'>
        <div className='container'>
          <div className='row quote-formss'>
            <div className='col-lg-6 col-md-12'>
              <h1>NEED HELP ?</h1>
              <p className='need-paragraph'>Choosing The Right Package</p>
              <div className='row padding-class'>
                <div className='col-md-6'>
                  <div class="icon-need-div">
                    <div class="icon">
                      <img src={consistent} />
                    </div>
                    <p className='normal-p'>	Contact a <strong class="yello-colors">Webflow WebDevelopment</strong></p>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div class="icon-need-div">
                    <div class="icon">
                      <img src={phonecall} />
                    </div>
                    <p className='normal-p'>	<a classname="ancher-link" href="tel:+(91) 9898582705">Schedule <strong class="yello-colors"> a call with us  </strong></a></p>
                  </div>
                </div>

              </div>
              <span className='heading-text'>+(91) 9898582705</span>
            </div>
            <div className='col-lg-2 col-md-0'></div>
            <div className='col-lg-4 col-md-12'>
              <section id="quote" className="bg-msar msar-quote-form">
                <section className="row">
                  <form onSubmit={sendEmail}>

                    <div className="col-md-12">
                      <div className="mt-4 white-text">Get Your Free</div>
                      <h4 className='white-text'>Consultation &amp; Quote</h4>
                      <div id="frm-quote">
                        <div className="form-group mt-4">
                          <input type="text"
                            className="form-control w-100 border-0"
                            placeholder="Name*"
                            name="name"
                            required
                          // onChange={onInputchange}
                          />
                        </div>

                        <div className="form-group">
                          <input type="text"
                            className="form-control w-100 border-0"
                            placeholder="Email*"
                            name="email"
                            required
                          // onChange={onInputchange}
                          />
                        </div>

                        <div className="form-group">
                          <select class="form-control w-100 border-0 p-2 " name='technology'
                          //  onChange={onInputchange}
                          >
                            <option value="Service">Service Required </option>
                            <option value="ReactJs">ReactJs Development</option>
                            <option value="NodeJs">NodeJs Developement</option>
                            <option value="WordPress">WordPress Development</option>
                            <option value="PHP">PHP Development</option>
                            <option value="Laravel">Laravel Development</option>
                            <option value="Flutter">Flutter Development</option>
                            <option value="Reactnative">React Native Development</option>
                            <option value="Android">Android Development</option>
                            <option value="IOS">IOS Development</option>
                            <option value="graIOTpefruit">IOT Development</option>
                            <option value="UIUX">UI/UX Development</option>
                            <option value="Shopify">Shopify Development</option>
                            <option value="Magento">Magento Development</option>
                            <option value="Layout">Layout Design</option>
                            <option value="Html">Html Development</option>
                            <option value="Logo">Logo Design</option>
                            <option value="Python">Python Development</option>
                          </select>
                        </div>

                        <div className="form-group mb-0">
                          <textarea className="form-group w-100 border-0 p-2 mb-0"
                            rows="2"
                            placeholder="Your Text"
                            // onChange={onInputchange}
                            name="message"
                            required
                          >
                          </textarea>
                        </div>

                        <div className="mt-0 pt-0 small white-text">* Need to fill marked. Make a call more details required.</div>
                        <button type="submit" className="btn-white-custom btn btn-sm mt-3"> Send Message </button>
                      </div>
                    </div>
                  </form>
                </section>
              </section>
            </div>

          </div>
        </div>
      </section>


      <Footer />
    </Layout>
  );
};
export default IotDevelopment;
